export function formatCurrencyHelper(value, truncationConfigs) {
  var _truncationConfig$dec, _truncationConfig$dec2;

  if (value === undefined || value === null) {
    return '$--';
  }

  var numberOfDigits = Math.round(value).toString().length;
  var truncationConfig = Object.prototype.hasOwnProperty.call(truncationConfigs, numberOfDigits) ? truncationConfigs[numberOfDigits] : {
    truncationAmount: 1,
    decimalDigits: 0,
    unitIdentifier: ''
  };
  var truncatedValue = value / truncationConfig.truncationAmount;
  truncatedValue = truncatedValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: (_truncationConfig$dec = truncationConfig.decimalDigits) !== null && _truncationConfig$dec !== void 0 ? _truncationConfig$dec : 0,
    maximumFractionDigits: (_truncationConfig$dec2 = truncationConfig.decimalDigits) !== null && _truncationConfig$dec2 !== void 0 ? _truncationConfig$dec2 : 0
  });
  return truncatedValue + truncationConfig.unitIdentifier;
}
export function formatEarnings(value) {
  var truncationConfigs = {
    6: {
      truncationAmount: 1000,
      unitIdentifier: 'K'
    },
    7: {
      truncationAmount: 1000000,
      decimalDigits: 1,
      unitIdentifier: 'M'
    },
    8: {
      truncationAmount: 1000000,
      unitIdentifier: 'M'
    }
  };
  return formatCurrencyHelper(value, truncationConfigs);
}
export function formatHomePrice(value) {
  var truncationConfigs = {
    7: {
      truncationAmount: 1000000,
      decimalDigits: 2,
      unitIdentifier: 'M'
    },
    8: {
      truncationAmount: 1000000,
      decimalDigits: 1,
      unitIdentifier: 'M'
    },
    9: {
      truncationAmount: 1000000,
      decimalDigits: 1,
      unitIdentifier: 'M'
    }
  };
  return formatCurrencyHelper(value, truncationConfigs);
}
export function formatListingPrice(value) {
  var truncationConfigs = {
    8: {
      truncationAmount: 1000000,
      decimalDigits: 1,
      unitIdentifier: 'M'
    },
    9: {
      truncationAmount: 1000000,
      unitIdentifier: 'M'
    }
  };
  return formatCurrencyHelper(value, truncationConfigs);
}
export function formatPercentagePrice(value) {
  var truncationConfigs = {
    6: {
      truncationAmount: 1000,
      unitIdentifier: 'K'
    },
    7: {
      truncationAmount: 1000000,
      decimalDigits: 2,
      unitIdentifier: 'M'
    },
    8: {
      truncationAmount: 1000000,
      unitIdentifier: 'M'
    }
  };
  return formatCurrencyHelper(value, truncationConfigs);
}